import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Col, FormGroup, Label, Row } from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from "react-select";
import { Validacao } from "../../comum/components/Validacao";

@inject("store")
@observer
export class DebitoForm extends Component {

    static propTypes = {
        contatoGlobo: PropTypes.object,
        setNome: PropTypes.func,
        setTelefone: PropTypes.func,
        setEmail: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        return (
            <div>
                <h4>Débito</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Centro de custo débito <sup>*</sup></Label>
                            <Select data-testid="centro-custo-debito-id"
                                cacheAsyncResults={false}
                                maxLength={6}
                                searchPromptText="Digite centro de custo débito"
                                noResultsText="Centro de custo inexistente ou inativa"
                                placeholder="Selecione..."
                                isLoading={this.controller.isLoadingArDebito || this.controller.isLoadingGestorArDebito}
                                value={this.controller.exibirDescricaoSolicitacaoCentroCustoDebito}
                                onChange={(value) => this.controller.setCentroCustoDebito(value)}
                                asyncOptions={(input, callback) => this.controller.filtrarAreaDebito(input, callback)}
                                disabled={!_.get(this.controller.solicitacao, "localContratacaoId")}
                            />
                            <Validacao id="arDebito" valor={this.controller.solicitacao.centroCustoDebito}
                                tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Gestor centro de custo débito <sup>*</sup></Label>
                            <Select options={this.controller.gestoresArDebito}
                                isLoading={this.controller.isLoadingGestorArDebito}
                                valueKey={"matricula"}
                                labelKey={"nome"}
                                value={this.controller.solicitacao.gestorAreaDebito}
                                onChange={(value, options) => this.controller.setGestorAreaDebito(value, options)}
                                placeholder="Selecione..."
                                noResultsText="Nenhum gestor encontrado para centro de custo débito"
                                disabled={!this.controller.solicitacao.centroCustoDebito}
                            />
                            <Validacao id="gestorAreaDebito" valor={this.controller.isGestorAreaDebitoSelecionado}
                                tipo={["isRequired"]} />
                            {/*<Alerta id="alertaArDebito" alertas={this.controller.gestorARError} isBloqueante/>*/}
                        </FormGroup>
                    </Col>
                </Row>
                {this.controller.isCentroCustoDebitoMediaPulse !== undefined &&
                    <span style={{ color: 'darkorange', display: 'block' }}>{this.controller.mensagemCentroCustoDebitoMediapulse}</span>
                }
            </div>
        )
    }
}